import { Controller } from "@hotwired/stimulus"

// Floating navbar: at the top of the page each reactive element wears its
// `idle` classes (inset, rounded, floating); once scrolled past `threshold`
// it swaps to its `scrolled` classes (full width, flush, squared off).
//
// Every element that should react carries:
//   data-navbar-target="reactive"
//   data-navbar-idle="<space separated classes>"
//   data-navbar-scrolled="<space separated classes>"
export default class extends Controller {
  static targets = ["reactive"]
  static values = { threshold: { type: Number, default: 8 } }

  connect() {
    this.scrolled = false
    this.onScroll = this.onScroll.bind(this)
    window.addEventListener("scroll", this.onScroll, { passive: true })
    this.onScroll()
  }

  disconnect() {
    window.removeEventListener("scroll", this.onScroll)
  }

  onScroll() {
    const y = window.scrollY
    const next = this.scrolled ? y > 0 : y > this.thresholdValue

    if (next === this.scrolled) return

    this.scrolled = next
    this.apply()
  }

  apply() {
    this.reactiveTargets.forEach((el) => {
      const add = this.scrolled ? el.dataset.navbarScrolled : el.dataset.navbarIdle
      const remove = this.scrolled ? el.dataset.navbarIdle : el.dataset.navbarScrolled

      if (remove) el.classList.remove(...remove.split(" "))
      if (add) el.classList.add(...add.split(" "))
    })
  }
}
